<template>
  <div id="card-status-gate">
    <vs-card>
      <div v-if="Sensor">
        <img src="@/assets/images/Unicorn/ggif.gif" />
      </div>
      <div v-else>
        <img src="@/assets/images/Unicorn/gateway.png" />
      </div>
    </vs-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Sensor: true,
    };
  },
  components: {},
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  padding: 10px;
}
</style>